import { render } from "./InputCheckboxPart.vue?vue&type=template&id=38627468&scoped=true"
import script from "./InputCheckboxPart.vue?vue&type=script&lang=js"
export * from "./InputCheckboxPart.vue?vue&type=script&lang=js"

import "./InputCheckboxPart.vue?vue&type=style&index=0&id=38627468&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38627468"]])

export default __exports__